module.exports = __webpack_public_path__ + "img/春节大促_15.3190126a.png";